import apiClient, { handleApiError } from './apiClient';

export interface CategoriaBase {
  nombre: string;
  descripcion?: string;
  activo: boolean;
}

export interface CategoriaResponse {
  id: number;
  nombre: string;
  descripcion: string;
  activo: boolean;
  fecha_creacion: string;
}

class CategoriasService {
  async getAll(activo?: boolean): Promise<CategoriaResponse[]> {
    try {
      const params = activo !== undefined ? { activo } : {};
      const response = await apiClient.get<any>('/productos/categorias/', { params });
      
      // Manejar respuesta paginada de Django REST Framework
      if (response.data && Array.isArray(response.data.results)) {
        return response.data.results;
      }
      
      // Si es un array directo, devolverlo
      if (Array.isArray(response.data)) {
        return response.data;
      }
      
      // Si no es ninguno de los anteriores, devolver array vacío
      console.error('Formato de respuesta inesperado:', response.data);
      return [];
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async getById(id: number): Promise<CategoriaResponse> {
    try {
      const response = await apiClient.get<CategoriaResponse>(`/productos/categorias/${id}/`);
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async create(data: CategoriaBase): Promise<CategoriaResponse> {
    try {
      const response = await apiClient.post<CategoriaResponse>('/productos/categorias/', data);
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async update(id: number, data: Partial<CategoriaBase>): Promise<CategoriaResponse> {
    try {
      const response = await apiClient.patch<CategoriaResponse>(`/productos/categorias/${id}/`, data);
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await apiClient.delete(`/productos/categorias/${id}/`);
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async toggleStatus(id: number): Promise<{ status: string; activo: boolean }> {
    try {
      const response = await apiClient.post<{ status: string; activo: boolean }>(
        `/productos/categorias/${id}/toggle_status/`
      );
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }
}

export const categoriasService = new CategoriasService();
export default categoriasService;
